import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let current_location_id = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location._id',
  })

  return {
    variables: {
      org_id: current_location_id,
      template_names: [
        'Layperson Diagnosis Letter',
        'Technical Diagnosis Letter',
      ],
    },
    pause: !current_location_id,
  }
}
